/* eslint-disable no-console */
import { makeUrl } from '../../utils/library';
import { API_URL } from '../../utils/config';
import { makeApiCall } from '../../redux/actions/common/common-action';
//NOTE: Called from Add payee page NewAddressBlock

function splitFullAddress(fullAddress) {
  let { length } = fullAddress,
    midL = length / 2,
    least = length;
  //iterating to find the comma nearest to half the length of the string
  for (let i = 0; i < length; i++)
    //if the string is comma and the difference between the mid-length and current index is less
    //than the difference between the previously set index and mid-length, this becomes our new
    //nearest index
    if (fullAddress[i] === ',' && Math.abs(midL - i) < Math.abs(midL - least)) least = i;
  //if none were found, split at nearest space after mid-length
  if (least === length) least = fullAddress.indexOf(' ', midL);
  return {
    address1: fullAddress.substring(0, least).replace(/^[,]\s*|[,]$/g, ''),
    address2: fullAddress.substring(least).replace(/^[,]\s*|[,]$/g, '')
  };
}

function checkArgsSuggestion(args) {
  let [params] = args;
  if (!params) throw new Error('params object not provided');
  // eslint-disable-next-line no-prototype-builtins
  if (!params.hasOwnProperty('keyword')) throw new Error('keyword in params not provided');
  // eslint-disable-next-line no-prototype-builtins
  if (!params.hasOwnProperty('country_code'))
    throw new Error('country_code in params not provided');
}

function checkArgsDetails(args) {
  let [params] = args;
  if (!params) throw new Error('params object not provided');
  // eslint-disable-next-line no-prototype-builtins
  if (!params.hasOwnProperty('placeId')) throw new Error('placeId in params not provided');
  // eslint-disable-next-line no-prototype-builtins
  if (!params.hasOwnProperty('country_code'))
    throw new Error('country_code in params not provided');
}

async function onSearchChangeDefault(params) {
  checkArgsSuggestion(arguments);
  if ((params.keyword || '').length < 3) return;
  let result = null;
  try {
    let response = await makeApiCall({
      method: 'GET',
      url: makeUrl(`${API_URL}/location/autocomplete`, params),
      withCredentials: true
    });
    if (response && response.data && response.data.success) {
      let {
          data: { totalNumPages: totalPages = 1, pageNum: page = 1, results, disable_fields }
        } = response.data,
        suggestions = results.map(({ placeId, suggestion }) => ({
          key: placeId,
          value: placeId,
          title: suggestion
        }));
      result = {
        totalPages,
        page,
        suggestions,
        disable_fields
      };
    }
  } catch (e) {
    console.error(e);
  }
  return result;
}

async function onSearchChangeSG(params, previous = []) {
  checkArgsSuggestion(arguments);
  if ((params.keyword || '').length < 5) return;
  let result = null;
  try {
    let response = await makeApiCall({
      method: 'GET',
      url: makeUrl(`${API_URL}/location/autocomplete`, params),
      withCredentials: true
    });
    if (response && response.data && response.data.success) {
      let {
          data: { totalNumPages: totalPages = 1, pageNum: page = 1, results, disable_fields }
        } = response.data,
        _prev = Array.isArray(previous) ? previous : [],
        suggestions = [
          ..._prev,
          ...results.map((each, index) => {
            return {
              key: _prev.length + index,
              value: _prev.length + index,
              title: each.suggestion,
              ...each
            };
          })
        ];
      result = {
        totalPages,
        page,
        suggestions,
        disable_fields
      };
    }
  } catch (e) {
    console.error(e);
  }
  return result;
}

export const SUGGESTION_HANDLER = {
  SG: onSearchChangeSG,
  default: onSearchChangeDefault
};

async function onSuggestionSelectedDefault(params) {
  checkArgsDetails(arguments);
  let result = null;
  try {
    let response = await makeApiCall({
      method: 'GET',
      url: makeUrl(`${API_URL}/location/details`, params),
      withCredentials: true
    });
    if (response && response.data && response.data.success) {
      let { data = {} } = response.data;
      result = { ...data, ...splitFullAddress(data.fullAddress || '') };
    }
  } catch (e) {
    console.error(e);
  }
  return result;
}

function onSuggestionSelectedSG({ placeId }, options = []) {
  checkArgsDetails(arguments);
  let result = null;
  if (placeId >= options.length || !options.length) return result;
  result = options[placeId];
  return result;
}

export const DETAIL_HANDLER = new Proxy(
  {
    SG: onSuggestionSelectedSG,
    default: onSuggestionSelectedDefault
  },
  {
    get: (target, prop) => {
      // eslint-disable-next-line no-prototype-builtins
      if (target.hasOwnProperty(prop)) return target[prop];
      return target.default;
    }
  }
);

export function normalizeSG(value = '', prev = '') {
  return /^\d{0,6}$/gi.test(value) ? value : prev;
}
